<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" @click="(showEdit = true), (opType = 'insert')">新增理财配置
                </el-button>
            </el-form-item>
        </el-form>

        <el-table :data="manageMoneyList">
            <el-table-column label="中文标题">
                <template slot-scope="scope">{{ getChineseName(scope.row.titleJson) }}</template>
            </el-table-column>
            <el-table-column label="币种" prop="coinType"/>
            <el-table-column label="类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.type === '2'">活期宝</span>
                    <span v-else-if="scope.row.type === '3'">定期宝</span>
                    <span v-else-if="scope.row.type === '4'">基金</span>
                    <span v-else>未知</span>
                </template>
            </el-table-column>
            <el-table-column label="热门">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.hot" active-color="#13ce66" inactive-color="#ff4949" disabled/>
                </template>
            </el-table-column>
            <el-table-column label="全部关心">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.allCares" active-color="#13ce66" inactive-color="#ff4949" disabled/>
                </template>
            </el-table-column>
            <el-table-column label="利率" prop="rate"/>
            <el-table-column label="排序" prop="sortNum"/>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="deleteRecord(scope.row.id)">删除</el-button>
                    <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="编辑理财配置" :visible.sync="showEdit" @close="closeEdit()">
            <el-form :model="editInfo" ref="financialForm" label-width="150px">
                <el-form-item label="主标题：">
                    <el-input v-model="nameTitle.zh" placeholder="中文"/>
                    <el-input v-model="nameTitle.en" placeholder="英文"/>
                    <el-input v-model="nameTitle.kr" placeholder="韩文"/>
                    <el-input v-model="nameTitle.vi" placeholder="越文"/>
                </el-form-item>
                <el-form-item label="副标题：">
                    <el-input v-model="nameSubtitle.zh" placeholder="中文"/>
                    <el-input v-model="nameSubtitle.en" placeholder="英文"/>
                    <el-input v-model="nameSubtitle.kr" placeholder="韩文"/>
                    <el-input v-model="nameSubtitle.vi" placeholder="越文"/>
                </el-form-item>
                <el-form-item label="描述：">
                    <el-input v-model="nameDescription.zh" placeholder="中文"/>
                    <el-input v-model="nameDescription.en" placeholder="英文"/>
                    <el-input v-model="nameDescription.kr" placeholder="韩文"/>
                    <el-input v-model="nameDescription.vi" placeholder="越文"/>
                </el-form-item>
                <el-form-item label="利率下方信息：">
                    <el-input v-model="detailJson.zh" placeholder="中文"/>
                    <el-input v-model="detailJson.en" placeholder="英文"/>
                    <el-input v-model="detailJson.kr" placeholder="韩文"/>
                    <el-input v-model="detailJson.vi" placeholder="越文"/>
                </el-form-item>
                <el-form-item label="币种：" prop="coinType"
                              :rules="[{ required: true, message: '币种不能为空', trigger: 'blur' }]">
                    <el-input v-model="editInfo.coinType"/>
                </el-form-item>
                <el-form-item label="类型：" prop="type" :rules="[{ required: true, message: '类型不能为空', trigger: 'blur' }]">
                    <el-select v-model="editInfo.type" @change="chooseType()">
                        <el-option v-for="item in types" :label="item.desc" :key="item.code" :value="item.code"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="利率：" prop="rate" :rules="[{ required: true, message: '利率不能为空', trigger: 'blur' }]">
                    <el-input v-model="editInfo.rate" :disabled="this.editInfo.type === '3'"/>
                </el-form-item>
                <el-form-item label="利率字符串：">
                    <el-input v-model="editInfo.rateString"/>
                </el-form-item>
                <el-form-item label="定期宝BusinessId" v-if="this.editInfo.type === '3'">
                    <el-input v-model="editInfo.businessId" disabled/>
                </el-form-item>
                <el-form-item label="链接：" prop="linkUrl"
                              :rules="[{ required: true, message: '链接不能为空', trigger: 'blur' }]">
                    <el-input v-model="editInfo.linkUrl"/>
                </el-form-item>
                <el-form-item label="排序：" prop="sortNum"
                              :rules="[{ required: true, message: '排序不能为空', trigger: 'blur' }]">
                    <el-input v-model="editInfo.sortNum"/>
                </el-form-item>
                <el-form-item label="是否热门">
                    <el-switch v-model="editInfo.hot" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="是否全部关心：">
                    <el-switch v-model="editInfo.allCares" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="图标：">
                    <upload v-model="editInfo.icon" :data="{ language: 1, platform: 1 }"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeEdit">取消</el-button>
                    <el-button type="primary" @click="submitEdit()">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="定期宝选择" :visible.sync="showFee">
            <el-table :data="list" highlight-current-row @current-change="boundFeeBusinessId">
                <el-table-column prop="id" label="ID"/>
                <el-table-column prop="period" label="期数"/>
                <el-table-column label="开始时间">
                    <template slot-scope="scope">
                        <span>{{ scope.row.startTime | moment }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间">
                    <template slot-scope="scope">
                        <span>{{ scope.row.endTime | moment }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="day" label="天数"/>
                <el-table-column prop="coinType" label="币种"/>
                <el-table-column prop="annualrate" label="年利率">
                    <template slot-scope="scope">
                        <span>{{ multiply(scope.row.annualrate, 100) }}%</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :total="totalCount"
                    :page-size="10"
                    :current-page="page"
                    @current-change="selectList"
            ></el-pagination>
        </el-dialog>
    </div>
</template>

<script>
    import api from "./api";
    import "../store";
    import {mapActions, mapGetters, mapState} from "vuex";
    import upload from "../../../components/upload";
    import math from "../../../common/math";

    export default {
        name: "manageMoney",
        data() {
            return {
                editInfo: {
                    icon: "",
                    coinType: "",
                    type: "",
                    titleJson: "",
                    subtitleJson: "",
                    descriptionJson: "",
                    hot: false,
                    allCares: false,
                    rate: "",
                    businessId: "",
                    linkUrl: "",
                    sortNum: "",
                    detailJson: ""
                },
                showEdit: false,
                opType: "",
                nameTitle: {
                    zh: "",
                    en: "",
                    kr: "",
                    vi: ""
                },
                nameSubtitle: {
                    zh: "",
                    en: "",
                    kr: "",
                    vi: ""
                },
                nameDescription: {
                    zh: "",
                    en: "",
                    kr: "",
                    vi: ""
                },
                detailJson: {
                    zh: "",
                    en: "",
                    kr: "",
                    vi: ""
                },
                rateString: "",
                types: [{code: "2", desc: "活期宝"}, {code: "3", desc: "定期宝"}, {code: "4", desc: "基金"}],
                showFee: false,
                page: 1
            };
        },
        components: {upload},
        computed: {
            ...mapState("PortalManage", ["manageMoneyList"]),
            ...mapState("pledgeInterest", ["totalCount"]),
            ...mapGetters("pledgeInterest", ["list"])
        },
        methods: {
            ...mapActions("PortalManage", ["selectManageMoney"]),
            ...mapActions("pledgeInterest", ["reqList"]),
            closeEdit() {
                this.showEdit = false;
                this.editInfo = {};
                this.opType = "";
                this.nameTitle = {};
                this.nameSubtitle = {};
                this.nameDescription = {};
                this.detailJson = {}
            },
            deleteRecord(id) {
                api.financialManageDelete({id: id}).then(() => {
                    this.$message.success("删除成功");
                    this.selectManageMoney();
                    this.closeEdit();
                });
            },
            openEdit(info) {
                console.log(info);
                this.editInfo = JSON.parse(JSON.stringify(info));
                if (this.editInfo.titleJson) {
                    this.nameTitle = JSON.parse(this.editInfo.titleJson);
                }
                if (this.editInfo.subtitleJson) {
                    this.nameSubtitle = JSON.parse(this.editInfo.subtitleJson);
                }
                if (this.editInfo.descriptionJson) {
                    this.nameDescription = JSON.parse(this.editInfo.descriptionJson);
                }
                if (this.editInfo.detailJson) {
                    this.detailJson = JSON.parse(this.editInfo.detailJson);
                }
                this.opType = "update";
                this.showEdit = true;
            },
            getChineseName(title) {
                return JSON.parse(title).zh;
            },
            submitEdit() {
                this.$refs["financialForm"].validate(valid => {
                    if (valid) {
                        this.editInfo.titleJson = JSON.stringify(this.nameTitle);
                        this.editInfo.subtitleJson = JSON.stringify(this.nameSubtitle);
                        this.editInfo.descriptionJson = JSON.stringify(this.nameDescription);
                        this.editInfo.detailJson = JSON.stringify(this.detailJson);
                        if (this.opType === "insert") {
                            api.financialManageCreate(this.editInfo).then(() => {
                                this.$message.success("新增成功");
                                this.selectManageMoney();
                                this.closeEdit();
                            });
                        }
                        if (this.opType === "update") {
                            api.financialManageUpdate(this.editInfo).then(() => {
                                this.$message.success("修改成功");
                                this.selectManageMoney();
                                this.closeEdit();
                            });
                        }
                    }
                });
            },
            chooseType() {
                if (this.editInfo.type === "3") {
                    this.showFee = true;
                    this.selectList(1);
                }
            },
            selectList(val) {
                this.page = val;
                this.reqList({page: this.page});
            },
            multiply(a, b) {
                return math.multiply(a, b);
            },
            boundFeeBusinessId(info) {
                console.log(info);
                this.editInfo.rate = info.annualrate;
                this.editInfo.businessId = info.id;
                this.showFee = false;
            }
        }
    };
</script>

<style scoped></style>
